(ns superadmin.page.db
  "Public events connected to initialization and manipulating
   superadmin dashboard page."
  (:require [clojure.string :as str]
            [re-frame.core :as rf]))

;; ID Lookup State Management

(rf/reg-event-db :superadmin/set-id-lookup-term
  (fn [db [_ term]]
    (assoc db :id-lookup-term term)))

(rf/reg-event-fx :superadmin/search-id
  (fn [{:keys [db]} _]
    (let [term (:id-lookup-term db)]
      (if (str/blank? term)
        {:db db}
        {:dispatch [:superadmin-resource.id-lookup/search term]}))))

(rf/reg-sub :superadmin/id-lookup-term
  (fn [db _]
    (get db :id-lookup-term "")))

(rf/reg-sub :superadmin/id-lookup-loading?
  :<- [:superadmin-resource.id-lookup/results]
  (fn [results _]
    (= :pending (:state results))))

(rf/reg-sub :superadmin/id-lookup-results
  :<- [:superadmin-resource.id-lookup/results]
  (fn [results _]
    (when (= :success (:state results))
      (:value results))))

;; Name Search State Management

(rf/reg-event-db :superadmin/set-name-search-term
  (fn [db [_ term]]
    (assoc db :name-search-term term)))

(rf/reg-event-fx :superadmin/search-name
  (fn [{:keys [db]} _]
    (let [term (:name-search-term db)]
      (if (str/blank? term)
        {:db db}
        {:dispatch [:superadmin-resource.name-search/search term]}))))

(rf/reg-sub :superadmin/name-search-term
  (fn [db _]
    (get db :name-search-term "")))

(rf/reg-sub :superadmin/name-search-loading?
  :<- [:superadmin-resource.name-search/results]
  (fn [results _]
    (= :pending (:state results))))

(rf/reg-sub :superadmin/name-search-results
  :<- [:superadmin-resource.name-search/results]
  (fn [results _]
    (when (= :success (:state results))
      (:value results))))
